<ng-container *ngIf="experimentComponent; else priceRequestForm">
  <ng-container *ngComponentOutlet="experimentComponent" />
</ng-container>

<ng-template #priceRequestForm>
  <ng-container *ngIf="priceRequest; else normalForm">
    <lx-price-request-form> </lx-price-request-form>
  </ng-container>
</ng-template>

<ng-template #normalForm>
  <lx-destination-school-form-section class="form-field__single-border-input" [formType]="formType" sectionIndex="1"></lx-destination-school-form-section>

  <lx-course-dates-form-section class="form-field__single-border-input" sectionIndex="2" [formType]="formType"></lx-course-dates-form-section>

  <lx-accommodation-dates-form-section class="form-field__single-border-input" sectionIndex="3"></lx-accommodation-dates-form-section>
  <lx-select-options-form-section sectionIndex="4"></lx-select-options-form-section>

  <lx-tell-us-about-you-section
    #tellUsAboutYouForm
    class="form-field__single-border-input"
    [formType]="formType"
    *ngIf="formType === FormType.PRICE_REQUEST || (this.formType === FormType.FREE_QUOTE && hasEnoughDataToGetSupplements)"
    [sectionIndex]="tellUsAboutYouSectionIndex"
    [validationRequests]="validationRequests$ | async"
    [withValidationErrors]="(stepValid$ | async) === false && (validationRequests$ | async) > 0"
  ></lx-tell-us-about-you-section>

  <lx-terms-and-promotions-form-section
    *ngIf="formType === FormType.PRICE_REQUEST || (this.formType === FormType.FREE_QUOTE && hasEnoughDataToGetSupplements)"
  ></lx-terms-and-promotions-form-section>
</ng-template>
